import { useShallow } from 'zustand/shallow'

import { useStore, getSelectedNodesSelector } from '@app/store'
import type { DomainNode } from '@app/types'

type UseGetSelectedNodes = (strategyId: string) => DomainNode[]

const useGetSelectedNodes: UseGetSelectedNodes = (strategyId) =>
  useStore(useShallow((state) => getSelectedNodesSelector(state, strategyId)))

export default useGetSelectedNodes
